import { Injectable } from '@angular/core';

import { ListResponse } from '../../models/list-response';

import { ApiService } from '../api/api.service';
import {
  VoucherPack,
  VoucherPackFilters, VoucherPackGiftDiscount, VoucherPackGiftDiscountFilters,
  VoucherPackGiftingConfig
} from '../../models/voucher-pack';
import { AccountingConnection } from '../../models/organization-config';


@Injectable({
  providedIn: 'root'
})
export class VoucherPackService {
  /**
   * A service providing access to voucher packs via the API.
   */

  constructor(
    private apiService: ApiService
  ) {}

  getVoucherPacks(pageNumber?: number,
                  pageSize?: number,
                  filters?: VoucherPackFilters): Promise<ListResponse<VoucherPack>> {
    return this.apiService.getCollection<VoucherPack, VoucherPackFilters>(
      'voucher-packs/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getVoucherPack(id: number): Promise<VoucherPack> {
    return this.apiService.getItem<VoucherPack>(
      'voucher-packs/',
      id
    );
  }

  addVoucherPack(voucherPack: VoucherPack): Promise<VoucherPack> {
    return this.apiService.postToAPI<VoucherPack>(
      'voucher-packs/',
      voucherPack
    );
  }

  updateVoucherPack(voucherPack: VoucherPack): Promise<VoucherPack> {
    return this.apiService.patchToAPI<VoucherPack>(
      voucherPack.url,
      voucherPack
    );
  }

  updateVoucherPackRevenueAccount(conn: AccountingConnection,
                                  voucherPack: VoucherPack,
                                  accountCode: string): Promise<void> {
    return this.apiService.postToAPI<any>(
      'gym-endpoints/set-voucher-pack-revenue-account-code/' + conn.id.toString() + '/' + voucherPack.id.toString() + '/',
      {account_code: accountCode}
    ).then();
  }

  getVoucherPackGiftingConfigs(): Promise<VoucherPackGiftingConfig[]> {
    return this.apiService.getFromAPI<VoucherPackGiftingConfig[]>(
      'voucher-pack-gifting-configs/'
    );
  }

  getVoucherPackGiftingConfig(id: number): Promise<VoucherPackGiftingConfig> {
    return this.apiService.getItem<VoucherPackGiftingConfig>(
      'voucher-pack-gifting-configs/',
      id
    );
  }

  addVoucherPackGiftingConfig(giftingConfig: VoucherPackGiftingConfig): Promise<VoucherPackGiftingConfig> {
    return this.apiService.postToAPI<VoucherPackGiftingConfig>(
      'voucher-pack-gifting-configs/',
      giftingConfig
    );
  }

  updateVoucherPackGiftingConfig(giftingConfig: VoucherPackGiftingConfig): Promise<VoucherPackGiftingConfig> {
    return this.apiService.patchToAPI<VoucherPackGiftingConfig>(
      giftingConfig.url,
      giftingConfig
    );
  }

  deleteVoucherPackGiftingConfig(giftingConfig: VoucherPackGiftingConfig): Promise<VoucherPackGiftingConfig> {
    return this.apiService.deleteFromAPI<VoucherPackGiftingConfig>(
      giftingConfig.url
    );
  }

  assignGiftingConfigToVoucherPacks(giftingConfigId: number,
                                    voucherPackIds: number[]): Promise<void> {
    return this.apiService.postToAPI<any>(
      'assign-gifting-config-to-voucher-packs/',
      {
        gifting_config_id: giftingConfigId,
        voucher_pack_ids: voucherPackIds
      }
    ).then();
  }

  getVoucherPackGiftDiscounts(pageNumber?: number,
                              pageSize?: number,
                              filters?: VoucherPackGiftDiscountFilters): Promise<ListResponse<VoucherPackGiftDiscount>> {
    return this.apiService.getCollection<VoucherPackGiftDiscount, VoucherPackGiftDiscountFilters>(
      'voucher-pack-gift-discounts/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getVoucherPackGiftDiscount(id: number): Promise<VoucherPackGiftDiscount> {
    return this.apiService.getItem<VoucherPackGiftDiscount>(
      'voucher-pack-gift-discounts/',
      id
    );
  }

  addVoucherPackGiftDiscount(discount: VoucherPackGiftDiscount): Promise<VoucherPackGiftDiscount> {
    if (discount.start_date === '') { discount.start_date = null; }
    if (discount.end_date === '') { discount.end_date = null; }

    return this.apiService.postToAPI<VoucherPackGiftDiscount>(
      'voucher-pack-gift-discounts/',
      discount
    );
  }

  updateVoucherPackGiftDiscount(discount: VoucherPackGiftDiscount): Promise<VoucherPackGiftDiscount> {
    if (discount.start_date === '') { discount.start_date = null; }
    if (discount.end_date === '') { discount.end_date = null; }

    return this.apiService.patchToAPI<VoucherPackGiftDiscount>(
      discount.url,
      discount
    );
  }

  deleteVoucherPackGiftDiscount(discount: VoucherPackGiftDiscount): Promise<VoucherPackGiftDiscount> {
    return this.apiService.deleteFromAPI<VoucherPackGiftDiscount>(
      discount.url
    );
  }

}
